
import { useEffect, useRef } from "react";
import { Helmet } from "react-helmet-async";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
// PainPoints is removed from imports
// import PainPoints from "@/components/PainPoints";
// Import is commented out but kept for future use
// import MonasticImpact from "@/components/MonasticImpact";
import Promise from "@/components/Promise";
import Testimonials from "@/components/Testimonials";
import TestimonialSlider from "@/components/TestimonialSlider";
import VideoTrailer from "@/components/VideoTrailer";
import Application from "@/components/Application";
import Footer from "@/components/Footer";

const Index = () => {
  const hasIntersectionObserver = useRef(typeof IntersectionObserver !== 'undefined');
  
  useEffect(() => {
    // Smooth scroll behavior
    document.documentElement.style.scrollBehavior = "smooth";
    
    // Prefetch critical images
    const prefetchImages = [
      '/lovable-uploads/0788554f-dbfe-44f8-bd67-7e7e91abbb3c.png',
      '/lovable-uploads/20b29789-0c27-4ca5-bc2c-8738168184c4.png',
      '/lovable-uploads/c40cb290-6bba-4300-a3b7-3dfa5c6877c5.png'
    ];
    
    // Prefetch PDF if available
    const prefetchPDF = [
      '/monastery-method-overview.pdf'
    ];
    
    if (window.requestIdleCallback) {
      window.requestIdleCallback(() => {
        prefetchImages.forEach(img => {
          const image = new Image();
          image.src = img;
        });
        
        // Prefetch PDF
        prefetchPDF.forEach(pdf => {
          const link = document.createElement('link');
          link.rel = 'prefetch';
          link.href = pdf;
          link.as = 'document';
          document.head.appendChild(link);
        });
      });
    } else {
      setTimeout(() => {
        prefetchImages.forEach(img => {
          const image = new Image();
          image.src = img;
        });
        
        // Prefetch PDF in setTimeout fallback
        prefetchPDF.forEach(pdf => {
          const link = document.createElement('link');
          link.rel = 'prefetch';
          link.href = pdf;
          link.as = 'document';
          document.head.appendChild(link);
        });
      }, 200);
    }
    
    return () => {
      document.documentElement.style.scrollBehavior = "";
    };
  }, []);

  // Structured data for SEO
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "ProfessionalService",
    "name": "The Monastery Method™",
    "description": "The Monastery Method™ applies timeless monastic principles to modern leadership, helping executives find clarity, purpose, and sustainable success.",
    "founder": {
      "@type": "Person",
      "name": "Tommy Zee",
      "jobTitle": "Leadership Coach",
      "image": "/lovable-uploads/20b29789-0c27-4ca5-bc2c-8738168184c4.png"
    },
    "offers": {
      "@type": "Offer",
      "name": "Executive Coaching Program",
      "description": "Transform your leadership through ancient monastic wisdom adapted for modern success"
    },
    "serviceType": ["Leadership Development", "Executive Coaching", "Mindfulness Training"],
    "sameAs": [
      "https://www.linkedin.com/in/tommyzee",
      "https://www.instagram.com/monasterymethod"
    ]
  };

  return (
    <div className="min-h-screen bg-white">
      <Helmet prioritizeSeoTags>
        <title>The Monastery Method™ | Ancient Wisdom, Modern Success</title>
        <meta name="description" content="Discover The Monastery Method™ where timeless monastic principles transform modern leadership. Learn practices for clarity, purpose, and sustainable success." />
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
        <link rel="canonical" href="https://monasterymethod.com" />
      </Helmet>
      
      <Navbar />
      <Hero />
      <main>
        {/* PainPoints component is removed */}
        {/* <PainPoints /> */}
        {/* MonasticImpact component is commented out but kept for future use
        <MonasticImpact /> */}
        <Promise />
        <Testimonials />
        <VideoTrailer />
        <TestimonialSlider />
        <Application />
      </main>
      <Footer showProgramOverview={true} />
    </div>
  );
};

export default Index;
